<template>
  <div class="tabbar">
    <mt-tab-item
      id="tab1"
      @click.native="currentTab = 'tab1'"
      :class="{ 'is-selected': currentTab === 'tab1' }"
    >
      <router-link to="/habits">
        <div class="flex flex-col m-1">
          <i class="material-icons">grass</i>
          <span class="mt-1">Habits</span>
        </div>
      </router-link>
    </mt-tab-item>
    <mt-tab-item
      id="tab2"
      @click.native="currentTab = 'tab2'"
      :class="{ 'is-selected': currentTab === 'tab2' }"
    >
      <router-link to="/tracker">
        <div class="flex flex-col m-1">
          <i class="material-icons">timeline</i>
          <span class="mt-1">Tracker</span>
        </div>
      </router-link>
    </mt-tab-item>
    <mt-tab-item
      id="tab3"
      @click.native="currentTab = 'tab3'"
      :class="{ 'is-selected': currentTab === 'tab3' }"
    >
      <router-link to="/about">
        <div class="flex flex-col m-1">
          <i class="material-icons">done_all</i>
          <span class="mt-1">About</span>
        </div>
      </router-link>
    </mt-tab-item>
  </div>
</template>

<script>
export default {
  computed: {
    currentTab: {
      get() {
        return this.$store.state.currentTab
      },
      set(selectedTab) {
        this.$store.commit('SET_CURRENT_TAB', selectedTab)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tabbar {
  background-image: linear-gradient(
    180deg,
    #d9d9d9,
    #d9d9d9 50%,
    transparent 50%
  );
  background-size: 100% 1px;
  background-repeat: no-repeat;
  background-position: top left;
  position: relative;
  background-color: #fafafa;
  display: flex;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  text-align: center;

  .mint-tab-item.is-selected {
    color: #1f74ff;
    background-color: #eaeaea;
  }
}
</style>
